module.exports = __webpack_public_path__ + "files/42a32ccb0d2886a129201606eac1f9f8.png";